// Bright daytime forest reading scene: whimsical children gathered on and
// around a log reading a magical book together, with deer families on either side.
export default function KidsIllustration({ className = "", ariaLabel = "Whimsical children reading a magical book together in a bright forest, with deer families on either side" }) {
  return (
    <svg
      viewBox="0 0 800 600"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label={ariaLabel}
      data-testid="kids-illustration"
    >
      <defs>
        <linearGradient id="daySky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#8DC7FF" />
          <stop offset="1" stopColor="#DFF3FF" />
        </linearGradient>
        <linearGradient id="dayGround" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#9CE39C" />
          <stop offset="1" stopColor="#3B9C4B" />
        </linearGradient>
        <radialGradient id="daySun" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="#FFF6A0" />
          <stop offset="0.7" stopColor="#FFD93D" />
          <stop offset="1" stopColor="#FFB347" />
        </radialGradient>
        <radialGradient id="dayCanopy" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="#9CE39C" />
          <stop offset="1" stopColor="#3B9C4B" />
        </radialGradient>
      </defs>

      <rect x="0" y="0" width="800" height="600" rx="30" ry="30" fill="url(#daySky)" />

      <g transform="translate(680 120)">
        <g opacity="0.85">
          {Array.from({ length: 12 }).map((_, i) => (
            <rect key={i} x="-3" y="-78" width="6" height="20" rx="3" fill="#FFD93D"
              transform={`rotate(${i * 30})`} />
          ))}
        </g>
        <circle r="44" fill="url(#daySun)" />
        <circle cx="-12" cy="-4" r="3.5" fill="#3D4EA0" />
        <circle cx="14" cy="-4" r="3.5" fill="#3D4EA0" />
        <path d="M -10 10 Q 0 18 10 10" stroke="#3D4EA0" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      </g>

      <g transform="translate(120 130)">
        <ellipse cx="0" cy="10" rx="46" ry="18" fill="#FFFFFF" />
        <circle cx="-24" cy="-2" r="18" fill="#FFFFFF" />
        <circle cx="10" cy="-12" r="22" fill="#FFFFFF" />
        <circle cx="32" cy="0" r="16" fill="#FFFFFF" />
      </g>
      <g transform="translate(430 100)">
        <ellipse cx="0" cy="8" rx="38" ry="14" fill="#FFFFFF" />
        <circle cx="-18" cy="-2" r="14" fill="#FFFFFF" />
        <circle cx="8" cy="-8" r="16" fill="#FFFFFF" />
      </g>

      <path d="M 300 200 q 6 -6 12 0 q 6 -6 12 0" stroke="#3D4EA0" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M 560 180 q 5 -5 10 0 q 5 -5 10 0" stroke="#3D4EA0" strokeWidth="2.5" fill="none" strokeLinecap="round" />

      <PineDay x={80} y={430} h={220} />
      <PineDay x={720} y={430} h={210} />
      <PineDay x={210} y={410} h={240} />
      <PineDay x={600} y={415} h={230} />

      <g>
        <circle cx="130" cy="340" r="70" fill="url(#dayCanopy)" />
        <rect x="124" y="390" width="12" height="60" fill="#5C3A22" />
        <circle cx="680" cy="345" r="65" fill="url(#dayCanopy)" />
        <rect x="674" y="395" width="12" height="60" fill="#5C3A22" />
        <circle cx="110" cy="330" r="4" fill="#FF6B9D" />
        <circle cx="150" cy="360" r="4" fill="#FFD93D" />
        <circle cx="660" cy="340" r="4" fill="#FF6B9D" />
      </g>

      <path d="M 0 460 Q 400 380 800 460 L 800 600 L 0 600 Z" fill="url(#dayGround)" />
      <path d="M 0 500 Q 400 430 800 500 L 800 600 L 0 600 Z" fill="#2E8C3E" opacity="0.85" />

      <g transform="translate(400 500)">
        <rect x="-150" y="-14" width="300" height="34" rx="14" fill="#8A5A2E" />
        <rect x="-150" y="-14" width="300" height="8" rx="4" fill="#B47A3B" />
        <ellipse cx="-150" cy="3" rx="10" ry="16" fill="#B47A3B" />
        <ellipse cx="-150" cy="3" rx="5" ry="8" fill="#8A5A2E" />
        <ellipse cx="150" cy="3" rx="10" ry="16" fill="#B47A3B" />
        <ellipse cx="150" cy="3" rx="5" ry="8" fill="#8A5A2E" />
        <path d="M -100 -14 q 15 -8 30 0 t 30 0 t 30 0 t 30 0 t 30 0" fill="#5CBB93" opacity="0.9" />
      </g>

      <g transform="translate(400 380)">
        <ellipse cx="-7" cy="-3" rx="7" ry="6" fill="#FF6B9D" />
        <ellipse cx="7" cy="-3" rx="7" ry="6" fill="#FF6B9D" />
        <ellipse cx="-6" cy="6" rx="5" ry="4" fill="#FFD93D" />
        <ellipse cx="6" cy="6" rx="5" ry="4" fill="#FFD93D" />
        <rect x="-1" y="-6" width="2" height="14" rx="1" fill="#3D4EA0" />
      </g>

      <g transform="translate(120 540)">
        <path d="M -6 0 Q -4 14 0 18 Q 4 14 6 0 Z" fill="#FFFFFF" />
        <path d="M -16 0 Q -14 -16 0 -16 Q 14 -16 16 0 Z" fill="#FF6B9D" />
        <circle cx="-6" cy="-8" r="2.5" fill="#FFFFFF" />
        <circle cx="4" cy="-10" r="3" fill="#FFFFFF" />
      </g>
      <g transform="translate(680 545)">
        <path d="M -5 0 Q -3 12 0 15 Q 3 12 5 0 Z" fill="#FFFFFF" />
        <path d="M -14 0 Q -12 -14 0 -14 Q 12 -14 14 0 Z" fill="#FFD93D" />
        <circle cx="-4" cy="-6" r="2.2" fill="#FFFFFF" />
        <circle cx="3" cy="-8" r="2.5" fill="#FFFFFF" />
      </g>

      {[
        { x: 60, y: 560, c: "#FF6B9D" },
        { x: 200, y: 560, c: "#FFD93D" },
        { x: 580, y: 560, c: "#B49FFF" },
        { x: 750, y: 555, c: "#FF8C42" },
      ].map((f, i) => (
        <g key={i} transform={`translate(${f.x} ${f.y})`}>
          <line x1="0" y1="0" x2="0" y2="14" stroke="#2E7D5B" strokeWidth="2.5" strokeLinecap="round" />
          <circle r="4" fill={f.c} />
          <circle r="1.5" fill="#FFD93D" />
        </g>
      ))}

      <g transform="translate(150 310)">
        <ellipse cx="0" cy="8" rx="18" ry="22" fill="#8A6B4A" />
        <ellipse cx="0" cy="12" rx="12" ry="16" fill="#E7C89A" />
        <path d="M -18 4 Q -24 18 -16 26 Z" fill="#5C4630" />
        <path d="M 18 4 Q 24 18 16 26 Z" fill="#5C4630" />
        <circle cx="-6" cy="-2" r="6" fill="#FFFFFF" />
        <circle cx="6" cy="-2" r="6" fill="#FFFFFF" />
        <circle cx="-6" cy="-2" r="3.5" fill="#1F2140" />
        <circle cx="6" cy="-2" r="3.5" fill="#1F2140" />
        <circle cx="-5" cy="-3" r="1.2" fill="#FFFFFF" />
        <circle cx="7" cy="-3" r="1.2" fill="#FFFFFF" />
        <path d="M -3 5 L 3 5 L 0 10 Z" fill="#FF8C42" />
        <path d="M -12 -14 L -8 -6 L -16 -4 Z" fill="#8A6B4A" />
        <path d="M 12 -14 L 8 -6 L 16 -4 Z" fill="#8A6B4A" />
      </g>

      <g transform="translate(600 528)">
        <path d="M 22 0 Q 44 -6 50 12 Q 40 20 20 14 Z" fill="#FF8C42" />
        <path d="M 44 4 Q 50 10 46 14 L 40 12 Z" fill="#FFF6D6" />
        <ellipse cx="0" cy="8" rx="26" ry="16" fill="#FF8C42" />
        <ellipse cx="-10" cy="14" rx="8" ry="8" fill="#FFF6D6" />
        <path d="M -26 4 Q -30 -8 -18 -12 L -6 -10 Q -4 -2 -12 2 Z" fill="#FF8C42" />
        <path d="M -24 -8 L -20 -18 L -18 -10 Z" fill="#FF8C42" />
        <path d="M -18 -10 L -12 -18 L -10 -8 Z" fill="#FF8C42" />
        <path d="M -22 -9 L -18 -14 L -17 -10 Z" fill="#1F2140" />
        <path d="M -26 4 L -32 0 L -26 -2 Z" fill="#FFF6D6" />
        <circle cx="-31" cy="0" r="1.5" fill="#1F2140" />
        <circle cx="-20" cy="-6" r="1.5" fill="#1F2140" />
      </g>

      <g transform="translate(400 460)">
        <path d="M -120 -8 L -4 -24 L -4 46 L -120 30 Z" fill="#FFFFFF" stroke="#B49FFF" strokeWidth="2" />
        <path d="M 4 -24 L 120 -8 L 120 30 L 4 46 Z" fill="#FFFFFF" stroke="#B49FFF" strokeWidth="2" />
        <rect x="-6" y="-24" width="12" height="70" fill="#FF6B9D" />
        {[-12, -2, 8, 18].map((y) => (
          <g key={y}>
            <line x1="-104" y1={y} x2="-20" y2={y - 2} stroke="#C7B5FF" strokeWidth="2" />
            <line x1="20" y1={y - 2} x2="104" y2={y} stroke="#C7B5FF" strokeWidth="2" />
          </g>
        ))}
        <g transform="translate(0 -50)">
          <circle r="4" fill="#FFD93D" />
          <circle cx="-28" cy="10" r="3" fill="#FF6B9D" />
          <circle cx="28" cy="10" r="3" fill="#4ECDC4" />
          <circle cx="-14" cy="-14" r="2.5" fill="#FFFFFF" />
          <circle cx="14" cy="-14" r="2.5" fill="#FFFFFF" />
        </g>
      </g>

      {/* Deer family on the LEFT near the trees */}
      <Deer x={95}  y={445} scale={0.85} flip={false} />
      <Deer x={170} y={480} scale={0.5}  flip={false} spots />

      {/* Deer family on the RIGHT near the trees */}
      <Deer x={710} y={450} scale={0.85} flip={true} />
      <Deer x={640} y={482} scale={0.5}  flip={true} spots />

      {/* Children reading the book together — sitting on the log and around it */}
      {/* Sitting on the log, LEFT side, leaning toward the book */}
      <SittingChild
        x={300} y={423}
        skin="#6B3E26" hair="#1B1B1B"
        outfit="#FF6B9D" style="curly"
        flip={false}
      />
      {/* Sitting on the log, RIGHT side, leaning toward the book */}
      <SittingChild
        x={500} y={423}
        skin="#F2C6A0" hair="#B47A3B"
        outfit="#7B8EFF" style="short"
        flip={true}
      />
      {/* Sitting on the ground, FRONT-LEFT of the log, looking up */}
      <SittingChild
        x={340} y={498}
        skin="#A56B47" hair="#3A1F14"
        outfit="#4ECDC4" style="braids"
        flip={false}
      />
      {/* Sitting on the ground, FRONT-RIGHT of the log */}
      <SittingChild
        x={460} y={498}
        skin="#8A5A38" hair="#2A1610"
        outfit="#FFD93D" style="curly"
        flip={true}
      />
    </svg>
  );
}

// Original simple flat-style child — sitting pose, arms reaching toward the book.
function SittingChild({ x, y, skin, hair, outfit, style, flip = false }) {
  return (
    <g transform={`translate(${x} ${y}) ${flip ? "scale(-1 1)" : ""}`}>
      {/* Sitting body */}
      <path d="M -28 20 Q -28 -8 -12 -8 L 12 -8 Q 28 -8 28 20 L 28 60 L -28 60 Z" fill={outfit} />
      <rect x="-26" y="55" width="52" height="10" rx="5" fill={outfit} />
      {/* Arms reaching toward book */}
      <path d="M 22 0 Q 44 10 58 22" stroke={skin} strokeWidth="9" strokeLinecap="round" fill="none" />
      <path d="M -22 0 Q -8 10 4 20" stroke={skin} strokeWidth="9" strokeLinecap="round" fill="none" />
      {/* Head */}
      <circle cx="0" cy="-30" r="22" fill={skin} />
      {/* Hair */}
      {style === "curly" && (
        <g fill={hair}>
          <circle cx="-14" cy="-44" r="8" />
          <circle cx="-4" cy="-52" r="9" />
          <circle cx="6" cy="-52" r="9" />
          <circle cx="16" cy="-44" r="8" />
          <circle cx="-20" cy="-34" r="7" />
          <circle cx="20" cy="-34" r="7" />
        </g>
      )}
      {style === "braids" && (
        <g fill={hair}>
          <path d="M -22 -32 Q -26 -50 -10 -54 L 10 -54 Q 26 -50 22 -32 Z" />
          <path d="M -24 -30 Q -28 -16 -22 -6" stroke={hair} strokeWidth="6" fill="none" strokeLinecap="round" />
          <path d="M 24 -30 Q 28 -16 22 -6" stroke={hair} strokeWidth="6" fill="none" strokeLinecap="round" />
          <circle cx="-23" cy="-4" r="3.5" fill="#FFD93D" />
          <circle cx="23" cy="-4" r="3.5" fill="#FFD93D" />
        </g>
      )}
      {style === "short" && (
        <path d="M -22 -30 Q -24 -52 0 -54 Q 24 -52 22 -30 L 18 -32 Q 6 -42 -6 -38 Q -16 -34 -18 -32 Z" fill={hair} />
      )}
      {/* Simple face */}
      <circle cx="-7" cy="-30" r="2.2" fill="#1F2140" />
      <circle cx="7" cy="-30" r="2.2" fill="#1F2140" />
      <path d="M -5 -20 Q 0 -15 5 -20" stroke="#1F2140" strokeWidth="2" fill="none" strokeLinecap="round" />
      <circle cx="-13" cy="-24" r="2.8" fill="#FF6B9D" opacity="0.55" />
      <circle cx="13" cy="-24" r="2.8" fill="#FF6B9D" opacity="0.55" />
    </g>
  );
}


function PineDay({ x, y, h }) {
  const w = h * 0.5;
  return (
    <g transform={`translate(${x} ${y})`}>
      <rect x={-5} y={-6} width={10} height={26} fill="#5C3A22" />
      <path d={`M ${-w / 2} 0 L 0 ${-h * 0.55} L ${w / 2} 0 Z`} fill="#3B9C4B" />
      <path d={`M ${-w / 2.4} ${-h * 0.32} L 0 ${-h * 0.82} L ${w / 2.4} ${-h * 0.32} Z`} fill="#4EAF52" />
      <path d={`M ${-w / 3} ${-h * 0.6} L 0 ${-h} L ${w / 3} ${-h * 0.6} Z`} fill="#6BC96F" />
    </g>
  );
}

function Deer({ x, y, scale = 1, flip = false, spots = false }) {
  const INK = "#1F2140";
  // Cute standing deer facing right by default (flip=true mirrors it).
  // Reference (x, y) is the top-of-legs / shoulder level. Feet reach ~y + 46*scale.
  const dir = flip ? -1 : 1;
  return (
    <g transform={`translate(${x} ${y}) scale(${scale * dir} ${scale})`}>
      {/* Legs */}
      <rect x="-30" y="0"  width="7" height="46" rx="2.5" fill="#B47A3B" />
      <rect x="-14" y="0"  width="7" height="46" rx="2.5" fill="#B47A3B" />
      <rect x="12"  y="0"  width="7" height="46" rx="2.5" fill="#B47A3B" />
      <rect x="28"  y="0"  width="7" height="46" rx="2.5" fill="#B47A3B" />
      {/* Hooves */}
      <ellipse cx="-26.5" cy="47" rx="5.5" ry="3" fill="#3A2515" />
      <ellipse cx="-10.5" cy="47" rx="5.5" ry="3" fill="#3A2515" />
      <ellipse cx="15.5"  cy="47" rx="5.5" ry="3" fill="#3A2515" />
      <ellipse cx="31.5"  cy="47" rx="5.5" ry="3" fill="#3A2515" />

      {/* Body */}
      <ellipse cx="0" cy="-8" rx="40" ry="20" fill="#B47A3B" />
      {/* Belly */}
      <ellipse cx="2" cy="4" rx="28" ry="8" fill="#FFF6D6" />

      {/* Spots for fawn */}
      {spots && (
        <g fill="#FFF6D6" opacity="0.95">
          <ellipse cx="-22" cy="-16" rx="3" ry="2.2" />
          <ellipse cx="-10" cy="-20" rx="3" ry="2.2" />
          <ellipse cx="2"   cy="-16" rx="3" ry="2.2" />
          <ellipse cx="14"  cy="-20" rx="3" ry="2.2" />
          <ellipse cx="-16" cy="-6"  rx="2.6" ry="2" />
          <ellipse cx="6"   cy="-6"  rx="2.6" ry="2" />
          <ellipse cx="-4"  cy="-24" rx="2.6" ry="2" />
        </g>
      )}

      {/* Tail */}
      <g transform="translate(-38 -16) rotate(-30)">
        <ellipse cx="0" cy="0" rx="6" ry="4" fill="#B47A3B" />
        <ellipse cx="-2" cy="-1" rx="3" ry="2.4" fill="#FFF6D6" />
      </g>

      {/* Neck */}
      <path d="M 28 -22 Q 44 -34 55 -28 L 52 -6 Q 40 0 28 -6 Z" fill="#B47A3B" />

      {/* Head */}
      <ellipse cx="58" cy="-32" rx="14" ry="12" fill="#B47A3B" />
      {/* Snout */}
      <ellipse cx="68" cy="-26" rx="8" ry="6" fill="#B47A3B" />
      {/* Snout light patch */}
      <ellipse cx="66" cy="-24" rx="6" ry="4" fill="#FFF6D6" />
      {/* Nose */}
      <ellipse cx="72" cy="-26" rx="3" ry="2" fill="#3A2515" />
      <circle cx="72.5" cy="-27" r="0.8" fill="#FFFFFF" opacity="0.7" />
      {/* Mouth */}
      <path d="M 70 -22 Q 66 -20 62 -22" stroke="#3A2515" strokeWidth="1.4" fill="none" strokeLinecap="round" />

      {/* Ears */}
      <g transform="translate(52 -46) rotate(-22)">
        <ellipse cx="0" cy="0" rx="4" ry="10" fill="#B47A3B" />
        <ellipse cx="-0.5" cy="1" rx="1.8" ry="6.5" fill="#FF9CB8" />
      </g>
      <g transform="translate(64 -46) rotate(18)">
        <ellipse cx="0" cy="0" rx="4" ry="10" fill="#B47A3B" />
        <ellipse cx="0.5" cy="1" rx="1.8" ry="6.5" fill="#FF9CB8" />
      </g>

      {/* Big gentle eye */}
      <ellipse cx="60" cy="-34" rx="3.2" ry="4.2" fill="#FFFFFF" />
      <ellipse cx="60" cy="-33" rx="2.4" ry="3.2" fill="#3A2515" />
      <circle cx="60" cy="-32.5" r="1.3" fill={INK} />
      <circle cx="60.6" cy="-34" r="0.7" fill="#FFFFFF" />
      {/* Lashes */}
      <line x1="57" y1="-37" x2="55" y2="-38.5" stroke={INK} strokeWidth="1.3" strokeLinecap="round" />
      <line x1="60" y1="-38" x2="60" y2="-40" stroke={INK} strokeWidth="1.3" strokeLinecap="round" />
      <line x1="63" y1="-37" x2="65" y2="-38.5" stroke={INK} strokeWidth="1.3" strokeLinecap="round" />

      {/* Rosy cheek */}
      <ellipse cx="65" cy="-28" rx="2.6" ry="1.8" fill="#FF6B9D" opacity="0.55" />

      {/* Small antler nub for adult only (subtle, doe-friendly) — omitted for now to keep it a doe */}
    </g>
  );
}
